exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.red-background[data-v-73e97744] {\n    background-color: rgb(255, 0, 82) !important;\n}\n", ""]);

// exports
